import { Skeleton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { RetrospectivesContainer } from './Retrospectives';

function RetrospectiveSkeleton() {
  return (
    <RetrospectivesContainer>
      <Table>
        <TableBody>
          <TableRow sx={{ width: '100%', '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="40%" />
            </TableCell>
          </TableRow>
          <TableRow sx={{ width: '100%', '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="40%" />
            </TableCell>
          </TableRow>
          <TableRow sx={{ width: '100%', '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="40%" />
            </TableCell>
          </TableRow>
          <TableRow sx={{ width: '100%', '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="40%" />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </RetrospectivesContainer>
  );
}

export default RetrospectiveSkeleton;
